import request from '../utils/request'

// 分页查询反馈列表（系统管理员）
export function getFeedbackList(params) {
  return request({
    url: '/feedback/list',
    method: 'get',
    params
  })
}

// 获取反馈详情
export function getFeedbackDetail(id) {
  return request({
    url: '/feedback/detail',
    method: 'get',
    params: { id }
  })
}


